import React from 'react';
import { Award, Users, Target, Star, Phone, Rocket } from 'lucide-react';
import Container from './Container';
import Button from './Button';

const achievements = [
  {
    icon: Award,
    title: '15+ Years Experience',
    description: 'Helping businesses grow their online presence since 2008'
  },
  {
    icon: Users,
    title: '500+ Clients',
    description: 'Successfully served businesses across North Carolina'
  },
  {
    icon: Target,
    title: 'Local Focus',
    description: 'Specialized in Raleigh and Triangle area businesses'
  },
  {
    icon: Rocket,
    title: 'Powered by OTTO',
    description: 'Advanced AI-driven SEO technology'
  }
];

const AboutUs = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <Container>
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">
            About SEO Raleigh
          </h1>
          
          <a href="tel:9192714871" className="flex items-center justify-center text-2xl text-blue-600 font-bold mb-8 hover:text-blue-700">
            <Phone className="h-6 w-6 mr-2" />
            (919) 271-4871
          </a>

          <div className="prose prose-lg max-w-none mb-12">
            <p className="text-xl text-gray-600 mb-6">
              Since 2008, SEO Raleigh has been at the forefront of digital marketing in North Carolina. 
              We specialize in helping local businesses dominate their markets through strategic SEO and 
              digital marketing solutions.
            </p>

            <p className="text-xl text-gray-600 mb-6">
              Led by our founder with over 15 years of experience in digital marketing, our team brings 
              deep expertise in local SEO, website optimization, and content strategy. We're proud to 
              serve businesses throughout Raleigh, Durham, Chapel Hill, and the greater Triangle area.
            </p>

            <p className="text-xl text-gray-600 mb-6">
              Our mission is simple: to help local businesses thrive in the digital age by providing 
              transparent, results-driven SEO services that deliver real value and measurable results.
            </p>

            <div className="bg-blue-50 p-8 rounded-2xl mb-6">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">
                Powered by Search Atlas & OTTO
              </h2>
              <p className="text-lg text-blue-800">
                We're proud to announce our strategic partnership with Search Atlas and their revolutionary 
                OTTO platform. This collaboration enables us to provide cutting-edge SEO services with 
                single keystroke deployment and superior optimization capabilities, setting a new standard 
                in digital marketing excellence.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {achievements.map((achievement, index) => (
            <div 
              key={index}
              className="text-center p-6 rounded-2xl border border-gray-200 hover:border-blue-500 transition-colors"
            >
              <div className="bg-blue-50 w-16 h-16 rounded-xl flex items-center justify-center mb-4 mx-auto">
                <achievement.icon className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold mb-2">{achievement.title}</h3>
              <p className="text-gray-600">{achievement.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button className="text-lg px-8 py-4" withArrow>
            Get in Touch
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default AboutUs;